import React from "react";
import { useLang } from "@/contexts/LanguageContext";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1577561426384-62154a1e9457?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtdXNsaW0lMjBwZW9wbGUlMjBwcmF5aW5nJTIwYXQlMjBtb3NxdWV8ZW58MHx8fHwxNzgwODE4NjM3fDA&ixlib=rb-4.1.0&q=85";

export default function AboutSection({ content }) {
  const { t, lang } = useLang();
  const text = lang === "ta" ? content?.about_ta : content?.about_en;
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";
  const fontB = lang === "ta" ? "font-sans-ta" : "";

  return (
    <section id="about" data-testid="about-section" className="bg-stone-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <img src={ABOUT_IMG} alt="Mosque interior" className="w-full h-[460px] object-cover rounded-2xl shadow-lg" />
          <div className="absolute -bottom-6 -right-6 hidden md:flex w-32 h-32 rounded-2xl bg-emerald-900 text-amber-300 items-center justify-center font-serif-en text-6xl shadow-xl">
            ﷲ
          </div>
        </div>
        <div>
          <span className="text-xs uppercase tracking-[0.3em] text-amber-700">عن المسجد</span>
          <h2 data-testid="about-heading" className={`${fontH} text-4xl md:text-5xl text-emerald-950 mt-2`}>
            {t("about_heading")}
          </h2>
          <div className="arabesque-divider my-6">۞</div>
          <p className={`text-stone-700 leading-relaxed text-base md:text-lg ${fontB}`}>{text}</p>
        </div>
      </div>
    </section>
  );
}
